import fields from "./fields.json";

export const schema = (datatype) => {
    const commons = fields[datatype];
    delete commons.id;
    return Object.values(commons);
};
